
const Footer = () => {
    return (

        <footer className="py-2 text-yellow-300 text-xs border-4 border-yellow-300 bg-black text-center">
            Copyright &copy; 2023 - Rolling Dices App by Eduard Vendrell
        </footer>
    )
}

export default Footer;